import type { ReactNode } from "react";

import { Navigate, useMatches } from "react-router";

import type { RouteHandle } from "shell/platform/types/types";

import { Loading } from "design-system/components/Loading";
import { pathsSchema } from "shell/platform/config/paths";
import { useRoles } from "shell/platform/hooks/useRoles";

export const AuthorizationGuard = ({ children }: { children: ReactNode }) => {
  const { hasRole, isLoading } = useRoles();
  const matches = useMatches();

  if (isLoading) {
    return <Loading isFullScreen size="large" />;
  }

  const requiredRoles = matches.flatMap(
    match => (match.handle as RouteHandle | undefined)?.roles ?? [],
  );

  if (requiredRoles.length > 0 && !hasRole(requiredRoles)) {
    return <Navigate to={pathsSchema.index} />;
  }

  return children;
};
